<!--AFFICHAGE BLOC GOOGLE -->
<template>

  <v-container v-if="this.condition()" fluid>

      <v-row dense>
      <v-col cols="12" >
        <v-card  v-if="this.condition()">
          <v-card-title>
            <a :href="url_climate_lab" target="_blank">
                    <img
                        title="Voir l'adresse dans ClimateApp" src="../../assets/logo_climatelab.png"
                    />
                 {{ adresse.numero_voie }}{{ adresse.indice_repetition }}&nbsp;{{
              adresse.libelle_type_voie
            }}&nbsp;{{ adresse.libelle_voie }}<br>
            <SimpleItem v-bind:var="adresse" data="complement_adresse" suffix="<br/>"></SimpleItem>
            <SimpleItem v-bind:var="adresse" data="distribution_speciale" suffix="<br/>"></SimpleItem>
            {{ adresse.code_postal }}&nbsp;{{ adresse.libelle_commune }}&nbsp;{{
              adresse.libelle_cedex
            }}&nbsp;{{ adresse.codeCedex }}<br>
            <SimpleItem v-bind:var="adresse" data="libelle_pays_etranger"></SimpleItem>
</a>


          </v-card-title>

          <GoogleMapModule :markers="markers" :mapcenter="center" :streetviewOn="false" :zoom="zoom"></GoogleMapModule>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn icon>
              <v-icon @click="zoom_out()">mdi-magnify-minus</v-icon>
            </v-btn>

            <v-btn icon>
              <v-icon @click="zoom_in()">mdi-magnify-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>
    </v-container>
</template>


<script>

import GoogleMapModule from "@/components/layout/GoogleMap";
import SimpleItem from '@/components/layout/SimpleItem';
//import OpenMap from "@/components/layout/OpenMap";




export default {
  name: 'GoogleView',
  components: { GoogleMapModule, SimpleItem},
  props: ['etablissement'],
  data() {
    return {
      defaultzoom_in: 17,
      defaultzoom_out: 4.5,
      zoom: 17,
    }
  },
  beforeCreate() {
      //this.$store.dispatch("initGoogleMapKeys")
  },

  computed: {
    adresse: function () {
      return this.$store.getters.getbloc("contact", "donnees", "adresse", null, "valeur")
    },
     adresse_libelle: function () {
      return this.$store.getters.getbloc("contact", "donnees", "adresse", null, "libelle")
    },


    googleReady : function () {
      return this.$store.getters.googleIsInitilized
    },
    center() {
      return this.markers[0].position
    },
    markers() {
      return [this.$store.getters.getbloc("info", "indicateurs", "google_location", null, "valeur")]
    },
    url_climate_lab() {
      return "https://climate-apps-prd.api.dsm.apps.generali.fr/?app=GEOSCAN&address="+encodeURIComponent(this.adresse_libelle)

    },
    markersOpenStreetMap() {
      return [this.markers[0].position.lat, this.markers[0].position.lng]
    }
  },

  methods: {

    condition() {
      return this.$store.getters.condition("info", "indicateurs", "google_location", null, "valeur")
    },
    zoom_in() {
      this.zoom = this.defaultzoom_in
    },
    zoom_out() {
      this.zoom = this.defaultzoom_out
    },


  }
};
</script>